import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  CalculatorOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  WhatsAppOutlined,
  UserSwitchOutlined,
} from '@ant-design/icons'
import { Dropdown, Button, Badge, Tooltip } from 'antd'
import { withTranslation } from 'react-i18next'
import Link from 'next/link'
import { withRouter } from 'next/router'
import {
  userSignOut,
  getBranch,
  setShowQuickCart,
  setShowEstimate,
  leaveImpersonation,
} from '../../actions'
import { getRolename } from '../../lib/AuthUtils'
import ReactGA from 'react-ga4'
import { ROLES } from '../../constants/AuthConstants'

class UserBar extends Component {
  constructor(props) {
    super(props)

    const { auth } = this.props
    const roleName = getRolename(auth)

    this.state = {
      roleName,
      // showWhatsApp: !!((roleName === 'cliente' || roleName === 'vendedor')),
      showWhatsApp: false,
    }
  }

  componentDidMount() {
    const { user } = this.props
    const { showWhatsApp, roleName } = this.state

    const branchId =
      roleName === 'cliente'
        ? user.sucursalId
        : roleName === 'vendedor'
          ? user.vendedor.sucursalId
          : null

    if (showWhatsApp) {
      this.props.getBranch(branchId)
    }
  }

  handleMenuClick = (e) => {
    switch (e.key) {
      case 'logout':
        this.props.userSignOut()
        break

      default:
        break
    }
  }

  render() {
    const { user, branch, role, currentQuotation, order, t } = this.props
    const { showWhatsApp } = this.state
    const username = user ? user.username : ''
    const adminToken = localStorage.getItem('adminToken')

    const WHATSAPP_MESSAGE = encodeURIComponent(t('whatsapp_message'))

    const handleWhatsAppClick = (contactName, phoneNumber, event) => {
      event.preventDefault()

      const event_params = {
        eventCategory: 'WhatsApp Link Clicked',
        eventLabel: 'WhatsApp engagement',
        branchName: branch.nombresucursal,
        contactName,
        phoneNumber,
      }

      ReactGA.event('startWhatsAppChat', event_params)

      setTimeout(() => {
        window.open(
          `https://api.whatsapp.com/send/?phone=549${phoneNumber}&text&type=phone_number&app_absent=0&text=${WHATSAPP_MESSAGE}`,
          '_blank',
        )
      }, 100)
    }

    const userItems = [
      {
        key: 'username',
        label: username,
        type: 'group',
        children: [
          { type: 'divider' },
          {
            key: 'profile',
            label: (
              <Link href={'/profile'}>
                <a>{t('My Profile')}</a>
              </Link>
            ),
          },
          { key: 'logout', label: t('Logout'), 'data-testid': 'logoutButton' },
        ],
      },
    ]

    const whatsappItems =
      branch && branch.contactLines
        ? branch.contactLines
            .filter((contact) => contact.phoneNumber && contact.contactName)
            .map((contact, index) => ({
              key: index.toString(),
              label: (
                <a
                  href='#'
                  onClick={(e) => handleWhatsAppClick(contact.contactName, contact.phoneNumber, e)}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {contact.contactName}
                </a>
              ),
            }))
        : []

    const estimateBadge =
      currentQuotation && currentQuotation.productos ? currentQuotation.productos.length : 0

    let orderBadge = 0
    if (order && order.productos) {
      orderBadge = order.productos.length
    }

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'flex-end',
          marginRight: '10px',
        }}
      >
        {adminToken && (
          <Tooltip title={t('leave impersonate')}>
            <Button
              type='primary'
              size='large'
              icon={<UserSwitchOutlined style={{ color: 'red', fontWeight: 'bold' }} />}
              style={{
                backgroundColor: 'yellow',
                borderColor: 'red',
                marginRight: '10px',
                borderWidth: '2px',
                borderRadius: '5px',
              }}
              onClick={() => this.props.leaveImpersonation()}
            />
          </Tooltip>
        )}
        {showWhatsApp && (
          <Dropdown
            menu={{ items: whatsappItems, onClick: this.handleMenuClick }}
            trigger={['click']}
          >
            <Button
              className='whatsapp-button-custom'
              icon={<WhatsAppOutlined style={{ fontSize: '32px', color: '#25D366' }} />}
            />
          </Dropdown>
        )}
        {role == ROLES.CLIENT && (
          <Badge count={estimateBadge} overflowCount={9999} className='icons-on-mobile mr-3'>
            <div className='actions'>
              <Tooltip title={t('Show quotation')}>
                <CalculatorOutlined
                  onClick={() => this.props.setShowEstimate()}
                  data-testid='calculator-antd-icon'
                  style={{ fontSize: '22px' }}
                />
              </Tooltip>
            </div>
          </Badge>
        )}
        {(role == ROLES.CLIENT || role == ROLES.SALESMAN) && this.props.router?.pathname !== '/cart' && (
          <Badge count={orderBadge} overflowCount={9999} className='icons-on-mobile mr-3'>
            <div className='actions'>
              <Tooltip title={t('Show cart')}>
                <ShoppingCartOutlined
                  onClick={() => this.props.router.push('/cart')}
                  data-testid='cart-antd-icon'
                  style={{ fontSize: '22px' }}
                />
              </Tooltip>
            </div>
          </Badge>
        )}
        <Dropdown
          menu={{ items: userItems, onClick: this.handleMenuClick }}
          className='logout-bar hidden-print'
          trigger={['click']}
        >
          <a className='ant-dropdown-link' href='#' data-testid='userMenu'>
            <UserOutlined style={{ fontSize: '22px' }} />
          </a>
        </Dropdown>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  getBranch: (branchId) => {
    dispatch(getBranch(branchId))
  },
  userSignOut: () => {
    dispatch(userSignOut())
  },
  setShowQuickCart: (data) => {
    dispatch(setShowQuickCart(data))
  },
  setShowEstimate: (data) => {
    dispatch(setShowEstimate(data))
  },
  leaveImpersonation: () => {
    dispatch(leaveImpersonation())
  },
})

const mapStateToProps = ({ auth, branches, quotation, orders }) => {
  const { user } = auth
  const currentQuotation = quotation.current
  const role = getRolename(auth)
  const { branch } = branches
  const { current } = orders

  return { auth, role, user, branch, currentQuotation, order: current }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(UserBar)))
